import { render } from "./CardEmail.vue?vue&type=template&id=015122df"
import script from "./CardEmail.vue?vue&type=script&lang=js"
export * from "./CardEmail.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\HRIS BCK\\digajiin_fe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__